<template>
  <div :tooltip="tooltip" flow="up" style="cursor: default">
    <span :class="['material-icons', iconStyle]">{{ iconName }}</span>
  </div>
</template>

<script>
export default {
  inject: ['companyUser'],
  props: {
    action: { type: Object, required: true },
  },
  computed: {
    iconName() {
      return {
        comment: 'comment',
        finish: 'done',
        position: 'file_download',
        weigh_and_empty: 'scale',
        empty: 'restore_from_trash',
        withdraw: 'file_upload',
        check: 'beenhere',
        pickup: 'restore_from_trash',
      }[this.action.action_name]
    },
    iconStyle() {
      if (this.fractionDisposalsEnabled()) {
        // Having a `null` key surprisingly works with map['null'] and map[null] (we need the latter)
        const map = {
          null: 'fraction-selection-clean',
          clean: 'fraction-selection-clean',
          mixed: 'fraction-selection-mixed',
          wrong: 'fraction-selection-wrong',
        }

        return map[this.action.fraction_disposal]
      } else if (this.action.action_name == 'check') {
        return 'check'
      } else {
        return null
      }
    },
    tooltip() {
      if (this.fractionDisposalsEnabled()) {
        // Having a `null` key surprisingly works with map['null'] and map[null] (we need the latter)
        const map = {
          null: this.$t('reporting.industry.fractionDisposals.clean'),
          clean: this.$t('reporting.industry.fractionDisposals.clean'),
          mixed: this.$t('reporting.industry.fractionDisposals.mixed'),
          wrong: this.$t('reporting.industry.fractionDisposals.wrong'),
        }

        return map[this.action.fraction_disposal]
      } else if (this.action.action_name == 'check') {
        return this.$t('orders.check')
      } else {
        return null
      }
    },
  },
  methods: {
    fractionDisposalsEnabled() {
      const fractionDisposalSelectionEnabled = !!this.companyUser.company.settings.enable_fraction_disposal_selection
      return fractionDisposalSelectionEnabled && ['empty', 'withdraw', 'check'].includes(this.action.action_name)
    },
  },
}
</script>

<style scoped>
.material-icons.fraction-selection-clean {
  color: green;
}

.material-icons.fraction-selection-mixed {
  /*
    Not using 'yellow' here as the background this icon is used on
    on one page is yellow-ish. This is a bit darker so we see it better.
  */
  color: #fab700;
}

.material-icons.fraction-selection-wrong {
  color: red;
}

.material-icons.check {
  color: #32b7bc;
}
</style>
